import { render, staticRenderFns } from "./tableSort.vue?vue&type=template&id=ae423fc8&"
import script from "./tableSort.vue?vue&type=script&lang=js&"
export * from "./tableSort.vue?vue&type=script&lang=js&"
import style0 from "./tableSort.vue?vue&type=style&index=0&id=ae423fc8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports